/**
 * Created by itaic on 12/7/15.
 */
/**
 /**
 * Extended ViewController template
 *
 * User: adic
 * Date: 5/9/13
 * Time: 3:22 PM
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    var lpUtils = require('utils/lpUtils');

    var App = window.App || {};
    var ButtonDropdownViewController = require('web-agent-components/ButtonDropdownViewController');
    var FormSelectionViewController = require('web-agent-components/FormSelectionViewController');
    var ViewController = require('web-agent-framework/ViewController');
    var SurveyLogic = require("survey-logic/surveylogicinstance.min");

    var AgentSurveyViewController = ViewController.extend({
        ControllerName: 'AgentSurveyViewController',
        applicationType: 'AgentSurveyViewController',

        LPViewMap: {
            surveyContainer: ".lpview_survey_container",
            surveyQuestionsContainer: ".lpview_survey_questions_container",
            surveyRow: ".lpview_survey_row",
            surveyState: ".lpview_survey_state",
            buttonRow: ".lpview_survey_button_row",
            retryButton: ".lpview_retry_button",
            button: ".lpview_survey_submit"
        },

        initialize: function (constructorData) {
            this.questionClassPrefix = "q";
            this.errorRows = {};
            this.loading = false;
            this.hidden = true;
            this.chatId = constructorData.chatId;
            if (constructorData.LPViewMap) { //Allow overriders for where to set the content
                for (var key in constructorData.LPViewMap) {
                    if (constructorData.LPViewMap.hasOwnProperty(key)) {
                        this.LPViewMap[key] = constructorData.LPViewMap[key];
                    }
                }
            }
        },

        events: function () {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            this.bindViewEvent({selector : this.LPViewMap.button, DOMEvent : "click", callback : this.submitButtonClicked});
            this.bindViewEvent({selector : this.LPViewMap.retryButton, DOMEvent : "click", callback : this.loadSurvey});
            this.bindModel({modelPath : participantPath + ".chats", callback : this.setChatId});
            this.bindModel({modelPath : participantPath + '.participantTag', callback: this.handleParticipantTag});
            this.bindModel({modelPath : participantPath + '.participantInfo.acceptedEngagement', callback : this.loadSurvey});
        },
        render: function () {}
    });



    AgentSurveyViewController.prototype.viewClasses = {
        showSurvey: "agent_survey_open",
        showLoading: "show_loading",
        itemError: "error"
    };

    AgentSurveyViewController.prototype.handleParticipantTag = function (data) {
        if (data.newValue) {
            if (this.colorTag) {
                this.removeClass(this.LPViewMap.surveyContainer, this.colorTag);
            }
            this.colorTag = data.newValue;
            this.addColorTag();
        }
    };

    AgentSurveyViewController.prototype.addColorTag = function () {
        if (this.colorTag && this.view) {
            this.addClass(this.LPViewMap.surveyContainer, this.colorTag);
        }
    };

    AgentSurveyViewController.prototype.setChatId = function (data) {
        var chatId;
        var chatIds = Object.keys(data.newValue);
        for (var chat in chatIds) {
            chatId = chatIds[chat];
            if (chatId && this.chatId !== chatId) {//Split session support
                this.chatId = chatId;
                this.loadSurvey();
            }
        }
    };

    AgentSurveyViewController.prototype.showLoading = function () {
        if (!this.loading) {
            if (this.loadingTimeout) {
                clearTimeout(this.loadingTimeout);
                this.loadingTimeout = null;
            }
            var that = this;
            this.loadingTimeout = setTimeout(function () {
                if (!that.loading) {
                    that.addClass(that.LPViewMap.surveyContainer, that.viewClasses.showLoading);
                    that.loading = true;
                }
            }, 250);
        }
    };

    AgentSurveyViewController.prototype.hideLoading = function () {
        if (this.loadingTimeout) {
            clearTimeout(this.loadingTimeout);
            this.loadingTimeout = null;
        }
        if (this.loading) {
            this.removeClass(this.LPViewMap.surveyContainer, this.viewClasses.showLoading);
            this.loading = false;
        }
    };

AgentSurveyViewController.prototype.loadSurvey = function() {
    if (!lpTag.WebAgent.logicController.isAcceptedEngagement(this.visitorId)) {
        return;
    }
    var hasMultipleAgentSurvey =lpTag.WebAgent.logicController.hasMultipleAgentSurvey() ;
    var isVisitorMonitored = lpTag.WebAgent.logicController.isVisitorMonitored(this.visitorId);
    if (hasMultipleAgentSurvey && isVisitorMonitored) {
        this.unbindModel({modelPath : 'participants.info.'+ this.visitorId + '.data.engagement', callback : _loadSurveyByEngagement});
        this.bindModel({modelPath : 'participants.info.'+ this.visitorId + '.data.engagement', callback : _loadSurveyByEngagement});
    } else {//only for monitoring for Amex issue- remove this when done - LE-72628
        this.logger.error('agentSurveyFlowDebugging, of visitorId: ' + this.visitorId + ' - no multiple agent survey or visitor is not monitored', 'AgentSurveyViewController._loadSurvey', {hasMultipleAgentSurvey: hasMultipleAgentSurvey, isVisitorMonitored: isVisitorMonitored});
        _loadSurvey.call(this);
    }

    function _loadSurveyByEngagement(data) {
        this.unbindModel({modelPath : 'participants.info.'+ this.visitorId + '.data.engagement', callback : _loadSurveyByEngagement});
        if (data && data.newValue && data.newValue.windowId) {
            this.unbindModel({modelPath : 'participants.info.'+ this.visitorId + '.data.window', callback : _loadSurvey});
            this.bindModel({modelPath : 'participants.info.'+ this.visitorId + '.data.window', callback : _loadSurvey});
        } else {
            //only for monitoring for Amex issue- remove this when done - LE-72628
            this.logger.error('agentSurveyFlowDebugging, of visitorId: ' + this.visitorId + ' - no windowId', '_loadSurveyByEngagement', data);_loadSurvey.call(this);
        }
    }

    function _loadSurvey(data) {
        var surveyId, surveyEnabled;
        this.unbindModel({modelPath : 'participants.info.'+ this.visitorId + '.data.window', callback : _loadSurvey});
        //only for monitoring for Amex issue- remove this when done - LE-72628
        this.logger.error('agentSurveyFlowDebugging, of visitorId: ' + this.visitorId, '_loadSurvey', data);        if(data && data.newValue){
            surveyId = data.newValue.surveyAgentChatId;
            surveyEnabled = data.newValue.surveyAgentChatEnabled;
        }

        this.lpHide(this.LPViewMap.retryButton);
        this.hideError();
        var request = {
            chatId: this.chatId,
            success: this.setSurvey,
            error: this.loadFailed,
            context: this
        };
        if (surveyEnabled && surveyId) {
            request.surveyApiId = surveyId;
        }
        //only for monitoring for Amex issue- remove this when done - LE-72628
        else {
            var cacheData = this.getModelParam('participants.infoServices.window.data');
            this.logger.error('agentSurveyFlowDebugging, of visitorId: ' + this.visitorId + ' - cache data', '_loadSurvey', {cacheData: cacheData});
        }var engagementSkillId = this.getModelParam('participants.info.' + this.visitorId + '.data.engagement.skillId');
        if (engagementSkillId) {
            request.engSkillId = engagementSkillId;
        }
        // Currently the default which is saved for all windows is surveyEnabled false and surveyId ''.
        // If it's the default - it's not really disabled, and we still want to show the survey
        if (surveyEnabled !== false || surveyId === '') {
            request.windowSurveyEnabled = true;
        } else {
            request.windowSurveyEnabled = false;
        }
        this.modelController.getAgentSurvey(request);
    }
};

    AgentSurveyViewController.prototype.loadFailed = function (data) {
        this.clearQuestions();
        this.lpHide(this.LPViewMap.button);
        this.hideSuccess();
        this.hideLoading();
        if (data && data.error) {
            if (data.error.message === "" || data.error.message === "Survey is inactive") {  //there is no survey defined
                this.showError(this.translate("SurveyIsInactive"));
                lpTag.WebAgent.logicController.setAgentSurveyLoadState({ chatId: this.chatId, state: false });
            } else {
                this.lpShow(this.LPViewMap.retryButton);
                this.showError(this.translate("surveyErrorsNoSurvey"));
            }
        }
    };

    AgentSurveyViewController.prototype.showError = function (errorText, errorChildren) {
        var stateView = this.getFirstElement(this.LPViewMap.surveyState);
        this.addClass(stateView, 'error');
        stateView.innerHTML = errorText;
        this.lpShow(stateView);
        if (errorChildren) {
            for (var i = 0; i < errorChildren.length; i++) {
                this.addRowError(errorChildren[i]);
            }
        }
        this.scrollToTop();
        stateView = null;
    };

    AgentSurveyViewController.prototype.hideError = function () {
        var stateView = this.getFirstElement(this.LPViewMap.surveyState);
        this.lpHide(stateView);
        this.removeClass(stateView, 'error');
        stateView.innerHTML = "";
        this.removeClassMultiElements(this.LPViewMap.surveyRow, this.viewClasses.itemError);
        this.errorRows = {};
        stateView = null;
    };

    AgentSurveyViewController.prototype.showSuccess = function (successText) {
        var stateView = this.getFirstElement(this.LPViewMap.surveyState);
        this.addClass(stateView, 'success');
        stateView.innerHTML = successText;
        this.lpShow(stateView);
        this.scrollToTop();
        stateView = null;
    };

    AgentSurveyViewController.prototype.hideSuccess = function () {
        var stateView = this.getFirstElement(this.LPViewMap.surveyState);
        this.lpHide(stateView);
        this.removeClass(stateView, 'success');
        stateView.innerHTML = "";
        stateView = null;
    };

    AgentSurveyViewController.prototype.scrollToTop = function () {
        if (this.view && this.view.parentNode && this.view.parentNode) {
            this.view.parentNode.scrollTop = 0;
        }
    };

AgentSurveyViewController.prototype.setSurvey = function (data) {
    this.hideError();
    if(data && data.survey) {
        this.surveyLogic = new SurveyLogic({ survey: data.survey, defaultSelectValue: this.translate("defaultSelectValue")});
        lpTag.WebAgent.logicController.setAgentSurveyLoadState({ chatId: this.chatId, state: true });
        var surveyState = this.getModelParam("chats." + this.chatId + ".agentSurvey.surveyState");
        if (surveyState === "Filled" || surveyState === "Filled-and-Wait") {
            this.showSuccess(this.translate("surveySubmitted"));
        } else {
            this.hideSuccess();
        }
        this.clearQuestions();
        this.renderQuestions(this.surveyLogic.getAllQuestions());
        this.updateView(this.surveyLogic.getActiveQuestions({getExcluded: true}));
        this.addColorTag();
        this.lpShow(this.LPViewMap.button);
        if (this.onResize) {
            this.onResize.callback.call(this.onResize.context);
        }
        this.hideLoading();
        this.hidden = false;
    }else{
        lpTag.WebAgent.logicController.setAgentSurveyLoadState({ chatId: this.chatId, state: false });
    }
};

    AgentSurveyViewController.prototype.clearQuestions = function () {
        for (var i = 0; i < this.viewControllers.length; i++) {
            this.viewControllers[i].dispose();
        }
        this.viewControllers = [];
        this.getFirstElement(this.LPViewMap.surveyQuestionsContainer).innerHTML = "";
    };

    AgentSurveyViewController.prototype.renderQuestions = function (questions, hideQuestions) {
        var questionsHtml = [];
        for (var i = 0; i < questions.length; i++) {
            var questionContainer = this.createView({//Create agent row
                target: this.LPViewMap.surveyQuestionsContainer,
                elementType: "div"
            });

            switch (questions[i].type) {
                case this.surveyLogic.questionTypes.RADIO:
                    this.renderRadioButton(questions[i], questionContainer);
                    break;
                case this.surveyLogic.questionTypes.RADIOH:
                    this.renderRadioButton(questions[i], questionContainer);
                    break;
                case this.surveyLogic.questionTypes.CHECKBOX:
                    this.renderCheckBoxes(questions[i], questionContainer);
                    break;
                case this.surveyLogic.questionTypes.SELECT:
                    this.renderSelect(questions[i], questionContainer);
                    break;
                case this.surveyLogic.questionTypes.TEXT:
                    this.renderTextArea(questions[i], questionContainer);
                    break;
                case this.surveyLogic.questionTypes.TEXTF:
                    this.renderInputTextField(questions[i], questionContainer);
                    break;
            }
            if (questionContainer && hideQuestions) {
                this.lpHide(questionContainer);
            }
            questionsHtml.push(questionContainer);
        }
        return questionsHtml;
    };

    AgentSurveyViewController.prototype.renderSelect = function (question, view) {
        var questionTemplate = {
            id: question.id,
            label: question.label,
            required: question.mandatory ? " required" : ''
        };

        var template = require("web-agent-templates/LP_agent_survey_item.html");
        // var template = lpUtils.loadResource("web-agent-templates/LP_agent_survey_item.html");
        view.innerHTML = this.templateString(template, questionTemplate, false);
        this.addClass(view.firstChild, "dropdown_fieldset");

        var answerIndex = getSelectedAnswerIndex(question.entry);

        var buttonDropdownViewController = new ButtonDropdownViewController({
            items: question.entry,
            selectedIndex: answerIndex,
            context: this,
            itemClicked: createCallback(this, question.id),
            textProperty: "value",
            buttonTitleEnabled: true
        });

        this.addViewController({viewController: buttonDropdownViewController, target: this.getFirstElement(this.LPViewMap.surveyRow, view)});

        function createCallback(context, questionId) {
            return function (data, callerForm) {
                context.selectChanged.call(context, questionId, data, callerForm);
            };
        }

        function getSelectedAnswerIndex(questionEntries) {
            for (var i = 0; i < questionEntries.length; i++) {
                if (questionEntries[i].checked) {
                    return i;
                }
            }

            return -1;
        }
    };

    AgentSurveyViewController.prototype.selectChanged = function (questionId, data) {
        this.answerQuestion(questionId, data.rowData.value);
    };

    AgentSurveyViewController.prototype.renderCheckBoxes = function (question, view) {
        var questionTemplate = {
            id: question.id,
            label: question.label,
            required: question.mandatory ? " required" : ''
        };

        var template = require("web-agent-templates/LP_agent_survey_item.html");
        // var template = lpUtils.loadResource("web-agent-templates/LP_agent_survey_item.html");
        view.innerHTML = this.templateString(template, questionTemplate, false);

        var that = this;
        var setMultiAnswer = function (answer) {//Closure scope for variables
            that.setMultiAnswer(question.id, question.entry[answer.rowIndex].value);//Timeout for IE's sake - render change first
        };

        var checkBoxComponent = new FormSelectionViewController({
            selectionOptions: question.entry,
            selectionType: "checkbox",
            selectionClickedCallback: setMultiAnswer,
            modifyData: false
        });

        this.addViewController({ viewController : checkBoxComponent, target : this.getFirstElement(this.LPViewMap.surveyRow, view) });
    };

    AgentSurveyViewController.prototype.setMultiAnswer = function (questionId, answer) {
        var exists = false;
        var answers = this.surveyLogic.getQuestionAnswersById(questionId);
        var newResult = [];

        for (var i = 0; i < answers.length; i++) {
            if (answer == answers[i]) {//Exclude if exists
                exists = true;
            } else {
                newResult.push(answers[i]);
            }
        }
        if (!exists) {//Include if missing
            newResult.push(answer);
        }
        this.answerQuestion(questionId, newResult);

        answers = null;
        newResult = null;
    };

    AgentSurveyViewController.prototype.renderRadioButton = function (question, view) {
        var questionTemplate = {
            id: question.id,
            label: question.label,
            required: question.mandatory ? " required" : ''
        };

        var template = require("web-agent-templates/LP_agent_survey_item.html");
        // var template = lpUtils.loadResource("web-agent-templates/LP_agent_survey_item.html");
        view.innerHTML = this.templateString(template, questionTemplate, false);

        var that = this;
        var submitAnswer = function (answer) {//Closure scope for variables
            that.answerQuestion(question.id, question.entry[answer.rowIndex].value);//Timeout for IE's sake - render change first
        };

        var radioButtonComponent = new FormSelectionViewController({
            selectionOptions: question.entry,
            selectionType: "radio",
            selectionClickedCallback: submitAnswer,
            modifyData: false
        });

        this.addViewController({ viewController : radioButtonComponent, target : this.getFirstElement(this.LPViewMap.surveyRow, view) });
    };

    AgentSurveyViewController.prototype.renderTextArea = function (question, view) {
        var questionTemplate = {
            id: question.id,
            label: question.label,
            lastKnownValue: question.lastKnownValue,
            required: question.mandatory ? 'required' : ''};

        var template = require("web-agent-templates/LP_agent_survey_textarea.html");
        // var template = lpUtils.loadResource("web-agent-templates/LP_agent_survey_textarea.html");

        view.innerHTML = this.templateString(template, questionTemplate, true);

        var that = this;
        var callback = function () {
            var answer = that.getFirstElement("textarea", view).value;
            that.answerQuestion(question.id, answer, true);
            answer = null;
        };

        this.bindViewEvent({selector : "textarea", DOMEvent : "keyup", callback : callback, inView : view});
        this.bindViewEvent({selector : "textarea", DOMEvent : "change", callback : callback, inView : view}); // for when Paste via mouse menus

        questionTemplate = null;
        template = null;
    };

    AgentSurveyViewController.prototype.renderInputTextField = function (question, view) {
        var questionTemplate = {
            id: question.id,
            label: question.label,
            lastKnownValue: question.lastKnownValue,
            required: question.mandatory ? "required" : ''
        };

        var template = require("web-agent-templates/LP_agent_survey_textInput.html");
        // var template = lpUtils.loadResource("web-agent-templates/LP_agent_survey_textInput.html");

        view.innerHTML = this.templateString(template, questionTemplate, true);

        var that = this;
        var callback = function () {
            var answer = that.getFirstElement("input", view).value;
            that.answerQuestion(question.id, answer, true);
            answer = null;
        };

        this.bindViewEvent({selector : "input", DOMEvent : "keyup", callback : callback, inView : view});
        this.bindViewEvent({selector : "input", DOMEvent : "change", callback : callback, inView : view}); // for when Paste via mouse menus

        questionTemplate = null;
        template = null;
    };

    AgentSurveyViewController.prototype.answerQuestion = function (questionId, answers, textAnswer) {
        if (textAnswer) {
            this.surveyLogic.submitAnswer(questionId, answers);
        } else {
            var nextStep = this.surveyLogic.submitAnswerGetNextQuestions(questionId, answers);
            this.updateView(nextStep);
            nextStep = null;
        }
        this.removeRowError(questionId);
    };

    AgentSurveyViewController.prototype.updateView = function (stateObj) {
        if (stateObj) {
            for (var i = 0; i < stateObj.questionsToShow.length; i++) {
                this.lpShow("." + this.questionClassPrefix + stateObj.questionsToShow[i].id);
            }
            for (var j = 0; j < stateObj.questionIdsToHide.length; j++) {
                this.lpHide("." + this.questionClassPrefix + stateObj.questionIdsToHide[j].id);
            }
        }
        if (this.onResize) {
            this.onResize.callback.call(this.onResize.context);
        }
    };

    AgentSurveyViewController.prototype.isSurveyEqualToLastSentSurvey = function(chatId, survey) {
        return !!chatId && !!survey && !!this.lastSurvey && chatId === this.lastChatId && JSON.stringify(survey) === JSON.stringify(this.lastSurvey);
    };

    AgentSurveyViewController.prototype.submitButtonClicked = function () {
        this.hideSuccess();
        this.hideError();
        this.showLoading();
        if (this.validateSurvey()) {
            var survey = this.surveyLogic.getJSONSurvey().survey;
            if (!this.isSurveyEqualToLastSentSurvey(this.chatId, survey)) {
                this.lastChatId = this.chatId;
                this.lastSurvey = survey;
                window.App.chatController.setAgentSurvey({
                    chatId: this.chatId,
                    survey: survey,
                    success: this.surveySubmitted,
                    error: this.surveySubmissionFailed,
                    context: this
                });
            } else {
                this.surveySubmitted();
            }
        } else {
            this.hideLoading();
        }
    };

    AgentSurveyViewController.prototype.validateSurvey = function () {
        var surveyResult = this.surveyLogic.validateSurvey(true);
        if (!surveyResult.surveyValid) {
            var questions = [];
            for (var i = 0; i < surveyResult.questionsNeeded.length; i++) {
                questions.push(surveyResult.questionsNeeded[i].id);
                this.errorRows[surveyResult.questionsNeeded[i].id] = true;
            }
            this.showError(this.translate("surveyErrorsGeneral"), questions);
            questions = null;
        }
        return surveyResult.surveyValid;
    };

    AgentSurveyViewController.prototype.surveySubmitted = function () {
        this.hideLoading();
        this.showSuccess(this.translate("surveySubmitted"));
    };

    AgentSurveyViewController.prototype.surveySubmissionFailed = function () {
        this.lastChatId = null;
        this.lastSurvey = null;
        this.hideLoading();
        this.showError(this.translate("surveyErrorsSubmissionFailure"));
    };

    AgentSurveyViewController.prototype.addRowError = function (questionId) {
        this.addClass("." + this.questionClassPrefix + questionId, this.viewClasses.itemError);
    };

    AgentSurveyViewController.prototype.removeRowError = function (questionId) {
        if (this.errorRows[questionId]) {
            this.removeClass("." + this.questionClassPrefix + questionId, this.viewClasses.itemError);
            delete this.errorRows[questionId];
        }
    };

    return AgentSurveyViewController;

});
